<div id="fullScreen" fxLayout="column">
  <h2 id="title" class="page-header" fxFill>Mantenimiento de Remito de Partes</h2>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
  <form fxLayout="column" style="margin: 2.5rem" [formGroup]="createRemitoForm" #formDirective="ngForm" autocomplete="off">
    <div id="cabacera" fxLayout="column">
      <h5 id="cabeceraHeader" class="section-header">Cabecera</h5>
      <mat-divider id="cabeceraDivider" class="mat-divider-header"></mat-divider>
      <div id="cabeceraForm" fxLayout="column" fxLayoutGap="1rem" style="margin: 2rem">
        <div id="cabeceraRow1" fxLayout="row wrap" fxLayoutAlign="space-between center">
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Pto Emision</mat-label>
            <mat-select placeholder="Pto Emision"  [(value)]="selectedOption" (selectionChange)="onChange($event)"  [disabled]="disablePtoEmision" disableOptionCentering panelClass="mat-select-dropdown">
              <mat-option *ngFor="let ptoEmision of allPtoEmision" [value]="ptoEmision.code" [formControl]="ptoEmisionControl" ngDefaultControl >
                {{ ptoEmision.code }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ptoEmisionControl.hasError('required')">Seleccione Pto de emision</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Nro Remito</mat-label>
            <input matInput placeholder="NRO Remito" [formControl]="nroRemitoControl">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Nro Ticket</mat-label>
            <input matInput #nroTicketInput maxlength="7" [formControl]="nroTicketControl"
                   (keypress)="keyPressNumbers($event)" placeholder="NRO Ticket">
            <mat-hint align="end">{{nroTicketInput.value.length || 0}}/7</mat-hint>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Clase <span class="required-indicator">*</span></mat-label>
            <mat-select [(value)]="claseSelected" [disabled]="this.remitoStatus === 'Impreso' || this.remitoStatus === 'Cancelado' || this.canView || this.remitoType === 'MGO'">
              <mat-option *ngFor="let clase of clase" [value]="clase.id">
                {{clase.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div id="cabeceraRow2" fxLayout="row wrap" fxLayoutAlign.gt-sm="start center" fxLayoutAlign.lt-md="space-between center" fxLayoutGap.gt-sm="1.33%" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Fec Gen</mat-label>
            <input matInput [matDatepicker]="fecGen" [formControl]="fecGenControl" required>
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="fecGen"></mat-datepicker-toggle>
            <mat-datepicker #fecGen></mat-datepicker>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Fec Salida</mat-label>
            <input matInput [matDatepicker]="fecSalida" [formControl]="fecSalidaControl" required>
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="fecSalida"></mat-datepicker-toggle>
            <mat-datepicker #fecSalida></mat-datepicker>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Fec a Retornar</mat-label>
            <input matInput [matDatepicker]="fecARetornar" [formControl]="fecARetornarControl" [disabled]="this.remitoType =='MGO'">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="fecARetornar"></mat-datepicker-toggle>
            <mat-datepicker #fecARetornar></mat-datepicker>
          </mat-form-field>
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" *ngIf="this.remitoType == 'MGO'">
            <mat-form-field fxFlex.gt-xs="49%" fxFlex.xs="100%" appearance="outline" >
              <mat-label>Shipper</mat-label>
              <input matInput placeholder="Shipper" [formControl]="nroShipperControl">
            </mat-form-field>
            <mat-form-field fxFlex.gt-xs="49%" fxFlex.xs="100%" appearance="outline">
              <mat-label>DUNS</mat-label>
              <input matInput placeholder="DUNS" [formControl]="dunsDockControl">
            </mat-form-field>
          </div>
        </div>
        <div id="cabeceraRow3" fxLayout="row wrap" fxLayoutAlign="space-between center">
          <mat-form-field fxFlex.gt-sm="49%" fxFlex.lt-md="100%" appearance="standard">
            <mat-label>Solicitante</mat-label>
            <input matInput [formControl]="solicitanteControl" [matAutocomplete]="autoSolicitante">
            <mat-autocomplete #autoSolicitante="matAutocomplete">
              <mat-option *ngFor="let solicitante of filteredSolicitante | async"
                          [value]="solicitante.id + ' - ' + solicitante.name"
                          (click)="solicitanteSelection(solicitante.id)">
                {{solicitante.id}} - {{solicitante.name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="solicitanteControl.hasError('required')">Seleccione un Solicitante</mat-error>
            <mat-error *ngIf="solicitanteControl.hasError('in-valid-list')">Seleccione un Solicitante Válido</mat-error>
            <mat-error *ngIf="solicitanteControl.hasError('dock-inactive')">Dock no esta activo.</mat-error>
            <mat-error *ngIf="solicitanteControl.hasError('almacen-blocked')">El departamento seleccionado tiene un Remito pendiente por retornar, seleccione otro ALMACEN o cierre el Remito abierto.</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Almacen <span class="required-indicator">*</span></mat-label>
            <input matInput maxlength="4" placeholder="Almacen" [formControl]="almacenControl">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Dock <span class="required-indicator">*</span></mat-label>
            <input matInput maxlength="4" placeholder="Dock" [formControl]="dockControl">
          </mat-form-field>
        </div>
        <div id="cabeceraRow4" fxLayout="row wrap" fxLayoutAlign.gt-sm="start center" fxLayoutAlign.lt-md="space-between center" fxLayoutGap.gt-sm="1.5%" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="49%" fxFlex.sm="65%" fxFlex.lt-sm="100%" appearance="standard">
            <mat-label>Transporte</mat-label>
            <input matInput [formControl]="transporteControl" [matAutocomplete]="autoTransporte" [readonly]="mgoInvalidDestinatario">
            <mat-autocomplete #autoTransporte="matAutocomplete">
              <mat-option *ngFor="let transporte of filteredTransporte | async"
                          [value]="transporte.id + ' - ' + transporte.desc">
                {{transporte.id}} - {{transporte.desc}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="transporteControl.hasError('required')">Seleccione un Transportista</mat-error>
            <mat-error *ngIf="transporteControl.hasError('in-valid-list')">Seleccione un Transportista Válido</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="33%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Patente</mat-label>
            <input matInput #patenteInput maxlength="10" placeholder="Patente" [formControl]="patenteControl">
            <mat-error *ngIf="patenteControl.hasError('required')">Aporte un Patente</mat-error>
            <mat-hint align="end">{{patenteInput.value.length || 0}}/10</mat-hint>
          </mat-form-field>
        </div>
        <div id="cabeceraRow5" fxLayout="row wrap" fxLayoutAlign.gt-sm="start center" fxLayoutAlign.lt-md="space-between center" fxLayoutGap.gt-sm="1.5%" fxLayoutGap.lt-md="0">
          <mat-form-field fxFlex.gt-sm="49%" fxFlex.sm="65%" fxFlex.lt-sm="100%" appearance="standard">
            <mat-label>Motivo</mat-label>
            <input type="text" matInput [formControl]="motivoControl" [matAutocomplete]="autoMotivo">
            <mat-autocomplete #autoMotivo="matAutocomplete">
              <mat-option *ngFor="let motivo of filteredMotivo | async" [value]="motivo.id + ' - ' + motivo.desc">
                {{motivo.id}} - {{motivo.desc}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="motivoControl.hasError('required')">Seleccione un Motivo</mat-error>
            <mat-error *ngIf="motivoControl.hasError('in-valid-list')">Seleccione un Motivo Válido</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="49%" fxFlex.sm="65%" fxFlex.lt-sm="100%" appearance="standard">
            <mat-label>Destinatario</mat-label>
            <input type="text" matInput [formControl]="destinatarioControl" [matAutocomplete]="autoDestinatario" [readonly]="mgoInvalidDestinatario">
            <mat-autocomplete #autoDestinatario="matAutocomplete">
              <mat-option *ngFor="let destinatario of filteredDestinatario | async"
                          [value]="destinatario.id + ' - ' + destinatario.desc + ' - ' +destinatario.city">
                {{destinatario.id}} - {{destinatario.desc}} - {{destinatario.city}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="destinatarioControl.hasError('required')">Seleccione un Destinatario</mat-error>
            <mat-error *ngIf="destinatarioControl.hasError('in-valid-list')">Seleccione un Destinatario Válido</mat-error>
          </mat-form-field>
        </div>
        <div id="cabeceraRow6" fxLayout="row wrap" fxLayoutAlign="space-between center">
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>P. Neto</mat-label>
            <input matInput (keypress)="keyPressNumbers($event)" [formControl]="pNetoControl" placeholder="P. Neto"
                   pattern="[0-9]{0,9}([.]{1}[0-9]{1,3})?">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Tara</mat-label>
            <input matInput (keypress)="keyPressNumbers($event)" [formControl]="taraControl" placeholder="Tara"
                   pattern="[0-9]{0,9}([.]{1}[0-9]{1,3})?">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>P. Bruto</mat-label>
            <input matInput (keypress)="keyPressNumbers($event)" [formControl]="pBrutoControl" placeholder="P. Bruto"
                   pattern="[0-9]{0,9}([.]{1}[0-9]{1,3})?">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="24%" fxFlex.sm="49%" fxFlex.lt-sm="100%" appearance="outline">
            <mat-label>Cant. Cont.</mat-label>
            <input matInput #cantContInput maxlength="5" [formControl]="cantContControl"
                   (keypress)="keyPressNumbers($event)" placeholder="Cant. Cont." pattern="[0-9]{0,9}?">
            <mat-hint align="end">{{cantContInput.value.length || 0}}/5</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div id="detalle" fxLayout="column" [hidden]="hideDetails">
      <h5 id="detalleHeader" class="section-header">Detalle</h5>
      <mat-divider id="detalleDivider" class="mat-divider-header"></mat-divider>
      <div id="detalleForm" fxLayout="column" fxLayoutAlign="none center" fxLayoutGap="1rem" style="margin: 2rem; text-align: center;" [formGroup]="form">
        <ng-container formArrayName="detalle">
          <ng-container *ngFor="let lessonForm of detalle.controls; let i = index">
            <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="1rem" [formGroupName]="i">
              <mat-form-field fxFlex="0 0 5.5rem" appearance="outline">
                <input matInput #itemInput maxlength="8" (keypress)="keyPressNumbers($event)"
                       formControlName="nroItemDet" placeholder="Item">
                <mat-hint align="end">{{itemInput.value.length || 0}}/8</mat-hint>
              </mat-form-field>
              <mat-form-field fxFlex="0 0 5.5rem" appearance="outline">
                <input matInput #parteInput maxlength="8"
                       formControlName="nroParte" placeholder="Parte">
                <mat-hint align="end">{{parteInput.value.length || 0}}/8</mat-hint>
              </mat-form-field>
              <mat-form-field fxFlex.gt-sm="0 0 24.5rem" fxFlex.lt-md="0 1 24.5rem"  appearance="outline">
                <input matInput #descripcionInput maxlength="40"
                       formControlName="descParte"
                       placeholder="Descripcion">
                <mat-hint align="end">{{descripcionInput.value.length || 0}}/40</mat-hint>
              </mat-form-field>
              <mat-form-field fxFlex="0 0 5.5rem" appearance="outline">
                <input matInput #cantidadInput maxlength="8" (keypress)="keyPressNumbers($event)"
                       formControlName="cantidad"
                       placeholder="Cantidad">
                <mat-hint align="end">{{cantidadInput.value.length || 0}}/8</mat-hint>
              </mat-form-field>
              <mat-form-field fxFlex="0 0 3.25rem" appearance="outline">
                <input matInput #uomInput maxlength="3"
                       formControlName="unidadMedida"
                       placeholder="UoM">
                <mat-hint align="end">{{uomInput.value.length || 0}}/3</mat-hint>
              </mat-form-field>
              <mat-form-field fxFlex="0 0 5.5rem" appearance="outline">
                <input matInput
                       formControlName="pesoNeto"
                       placeholder="Peso Neto"
                       pattern="[0-9]{0,9}([.]{1}[0-9]{1,3})?">
              </mat-form-field>
              <mat-icon color="warn" (click)="deleteLesson(i)" [hidden]="this.remitoStatus === 'Impreso' || this.remitoStatus === 'Cancelado' || this.canView || this.remitoType === 'MGO'">delete</mat-icon>
            </div>
          </ng-container>
        </ng-container>
        <button mat-mini-fab type="button" color="accent" (click)="addDetalle(detalle.controls.length)" [hidden]="this.remitoStatus === 'Impreso' || this.remitoStatus === 'Cancelado' || this.canView || this.remitoType === 'MGO'">
          <mat-icon class="add-course-btn">add</mat-icon>
        </button>
      </div>
    </div>
    <div id="observacion" fxLayout="column" [hidden]="hideObservacion">
      <h5 class="section-header">Observación</h5>
      <mat-divider class="mat-divider-header"></mat-divider>
      <div fxLayout="column" fxLayoutAlign="center stretch" style="margin: 2rem">
        <mat-form-field appearance="outline">
          <mat-label>Observación</mat-label>
          <input matInput #observacion1Input maxlength="100" [formControl]="observacionControl1"
                 placeholder="Observación">
          <mat-hint align="end">{{observacion1Input.value.length || 0}}/100</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Observación</mat-label>
          <input matInput #observacion2Input maxlength="100" [formControl]="observacionControl2"
                 placeholder="Observación">
          <mat-hint align="end">{{observacion2Input.value.length || 0}}/100</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Observación</mat-label>
          <input matInput #observacion3Input maxlength="100" [formControl]="observacionControl3"
                 placeholder="Observación">
          <mat-hint align="end">{{observacion3Input.value.length || 0}}/100</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div id="prorrogas" *ngIf="this.remitoStatus == 'Impreso' && this.fecARetornarControl.value" [hidden]="hideProrrogas">
      <h5 id="prorrogasHeader" class="section-header">Prorrogas</h5>
      <mat-divider id="prorrogasDivider" class="mat-divider-header"></mat-divider>
      <div id="prorrogasForm" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="1rem" style="margin: 2rem; text-align: center;" [formGroup]="form">
        <ng-container formArrayName="prorrogas">
          <ng-container *ngFor="let prorrogasForm of prorrogas.controls; let i = index">
            <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="0.75rem" [formGroupName]="i">
              <mat-form-field fxFlex="0 0 9rem" appearance="outline">
                <mat-label>Fecha</mat-label>
                <input matInput [matDatepicker]="fecProrrogas" formControlName="fecProrrogas" [min]="this.tomorrow">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="fecProrrogas"></mat-datepicker-toggle>
                <mat-datepicker #fecProrrogas></mat-datepicker>
              </mat-form-field>
              <mat-form-field fxFlex="0 0 36rem" appearance="outline">
                <mat-label>Observación</mat-label>
                <input matInput #observacion maxlength="100"
                       formControlName="observacion" placeholder="Observación">
                <mat-hint align="end">{{observacion.value.length || 0}}/100</mat-hint>
              </mat-form-field>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div id="retorno" class="retorno" *ngIf="this.remitoStatus == 'Impreso' && this.fecARetornarControl.value" [hidden]="hideRetorno">
      <h5 id="retornoHeader" class="section-header">Retorno</h5>
      <mat-divider id="retornoDivider" class="mat-divider-header"></mat-divider>
      <div id="retornoForm" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="0.75rem" style="margin: 2rem; text-align: center;">
        <mat-form-field fxFlex="0 0 9rem" appearance="outline">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="fechaRetornoInput" [formControl]="fechaRetornoControl"
                 [max]="this.today">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="fechaRetornoInput"></mat-datepicker-toggle>
          <mat-datepicker #fechaRetornoInput></mat-datepicker>
        </mat-form-field>
        <mat-form-field fxFlex="0 0 36rem" appearance="outline">
          <mat-label>Doc Retorno</mat-label>
          <input matInput #docRetornoInput maxlength="100" [formControl]="docRetornoControl"
                 placeholder="Doc Retorno">
          <mat-hint align="end">{{docRetornoInput.value.length || 0}}/100</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div id="footerButtons" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1.5rem" style="text-align:center;">
      <button mat-raised-button fxFlex="0 1 10rem" color="primary" style="width:150px; margin:10px;" type="button" (click)="save()" [disabled]="saveDisabled || this.canView || isSaving">
        <mat-spinner *ngIf="isSaving" class="loading-spinner-small" diameter="30"></mat-spinner>
        <span *ngIf="!isSaving">Guardar</span>
      </button>
      <button mat-raised-button fxFlex="0 1 10rem" color="accent" style="width:150px; margin:10px;" type="button" (click)="clearForm()" [disabled]="isView || this.canView">
        Limpiar
      </button>
    </div>
  </form>
  <app-required-message></app-required-message>
</div>
